import React, { FC } from 'react'
import styles from './CuratedDeals.module.scss'
import Fallback from 'components/SA/Fallback'
import { FALLBACK_DATA, TILES_DATA } from '../helpers'
import TileList from 'components/SA/Fallback/Tiles/TilesList'

const Blackout: FC = () => {
  const { title, subTitle, description } = FALLBACK_DATA
  return (
    <Fallback
      title={title}
      subTitle={subTitle}
      description={description}
      customTitleStyle={styles.blackoutTitle}
    >
      <div className={styles.tilesRow}>
        <p>Explore These In The Meantime</p>
        <TileList tiles={TILES_DATA} />
      </div>
    </Fallback>
  )
}

export default Blackout
